export default "__VITE_ASSET__eee17460__"